export default "__VITE_ASSET__DNCuUBu4__"